// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"532":"styles","691":"component---src-pages-index-tsx","948":"2cca2479","976":"c16184b3"}[chunkId] || chunkId) + "-" + {"532":"c3e3431583eb4ec22616","691":"5faed55318327ede72ba","948":"1ff759fba1cd953a2ee5","954":"d80d3af7d3fb23684e3e","976":"1a85c6cb4d3d9b0d73bd"}[chunkId] + ".js";
};